import { cva } from 'class-variance-authority';
const gridColsMap = {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
    5: 'grid-cols-5',
    6: 'grid-cols-6',
    12: 'grid-cols-12',
};
const gridGapMap = {
    0: 'gap-0',
    1: 'gap-1',
    2: 'gap-2',
    3: 'gap-3',
    4: 'gap-4',
    5: 'gap-5',
    6: 'gap-6',
    8: 'gap-8',
    10: 'gap-10',
    12: 'gap-12',
};
const gridFlowMap = {
    row: 'grid-flow-row',
    col: 'grid-flow-col',
    dense: 'grid-flow-dense',
    'row-dense': 'grid-flow-row-dense',
    'col-dense': 'grid-flow-col-dense',
};
/** CVA variants 맵 — lab·문서용 키 추출의 SSOT. */
export const gridCva = {
    variants: {
        cols: gridColsMap,
        gap: gridGapMap,
        flow: gridFlowMap,
    },
    defaultVariants: {
        cols: 1,
        gap: 2,
        flow: 'row',
    },
};
export const gridVariants = cva('grid', gridCva);
/** CVA cols variant 키 (삽입 순서 유지). */
export const gridColsKeys = Object.keys(gridCva.variants.cols).map(Number);
/** CVA gap variant 키 (삽입 순서 유지). */
export const gridGapKeys = Object.keys(gridCva.variants.gap).map(Number);
/** CVA flow variant 키 (삽입 순서 유지). */
export const gridFlowKeys = Object.keys(gridCva.variants.flow);
//# sourceMappingURL=grid.cva.js.map